import { render, staticRenderFns } from "./PreRegisterSection.vue?vue&type=template&id=77bd131c&scoped=true"
import script from "./PreRegisterSection.vue?vue&type=script&lang=js"
export * from "./PreRegisterSection.vue?vue&type=script&lang=js"
import style0 from "./PreRegisterSection.vue?vue&type=style&index=0&id=77bd131c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd131c",
  null
  
)

export default component.exports